import UAParser from "ua-parser-js";

export class DeviceModelDetection {
    private device: UAParser.IDevice;
    constructor(private parser: UAParser) {
        this.device = this.parser.getDevice();
    }

    /**
     * Is it an iPhone?
     */
    public get isIphone() {
        return this.device.vendor === "Apple" && this.device.model === "iPhone";
    }

    public get isIpad() {
        return this.device.vendor === "Apple" && this.device.model === "iPad";
    }

}
